/* eslint-disable max-len */
import {
  compose, lifecycle, withHandlers, withState, withStateHandlers,
} from 'recompose';
import { remove } from 'ramda';
import { connect } from 'react-redux';

import { withRouter } from 'react-router';
import { closeModal, uploadTempFileRequest } from '../../../../state/ui/actions';
import { getModal, getTempFileUploadPending } from '../../../../state/ui/selectors';
import ImportCustomers from './importCustomers';
import { customersActions } from '../../../../state/customers';

const mapStateToProps = state => ({
  isOpen: getModal(state)('importCustomers'),
  isPending: getTempFileUploadPending(state),
});

const mapDispatchToProps = ({
  onCloseModal: () => closeModal('importCustomers'),
  uploadTempFile: uploadTempFileRequest,
  importCustomers: customersActions.importCustomersRequest,
});

const onChangeHandler = ({ setFilesList, onResetLoadingFiles }) => (e) => {
  onResetLoadingFiles();
  const filesList = Array.from(e.currentTarget.files);
  setFilesList(filesList[0]);
};

const onUploadFilesHandler = ({
  filesList, uploadTempFile, setLoadingFiles, loadingFiles,
}) => () => {
  if (!filesList) return null;
  const formData = new FormData();
  formData.append('file', filesList);
  return uploadTempFile(formData, {
    callbacks: {
      success: ({ model }) => {
        setLoadingFiles(loadingFiles.concat(model));
      },
    },
  });
  // const previewData = URL.createObjectURL(e.currentTarget.files[0]);
  // const formData = new FormData();
  // formData.append('file', e.currentTarget.files[0]);
};

const setLoadingFilesStateHandler = ({ loadingFiles }) => item => ({ loadingFiles: loadingFiles.concat(item) });

const onDeleteFileStateHandler = ({ loadingFiles }) => index => ({ loadingFiles: remove(index, 1, loadingFiles) });

const onImportCustomersHandler = ({
  loadingFiles, onCloseModal, setFilesList, onResetLoadingFiles, importCustomers,
}) => (e) => {
  e.preventDefault();
  if (!loadingFiles[0].id) return null;
  importCustomers({
    file_id: loadingFiles[0].id,
  }, {
    callbacks: { success: () => { onCloseModal(); setFilesList([]); onResetLoadingFiles([]); } },
  });
  return e;
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withState('filesList', 'setFilesList', 0),
  withStateHandlers(() => ({ loadingFiles: [] }), {
    onResetLoadingFiles: () => () => ({ loadingFiles: [] }),
    setLoadingFiles: setLoadingFilesStateHandler,
    onDeleteFile: onDeleteFileStateHandler,
  }),
  withHandlers({
    onChange: onChangeHandler,
    onUploadFiles: onUploadFilesHandler,
    onImportCustomers: onImportCustomersHandler,
  }),
  lifecycle({
    componentDidUpdate({ filesList }) {
      if (this.props.filesList !== filesList) {
        this.props.onUploadFiles();
      }
    },
  }),
);

export default enhance(ImportCustomers);
